/**
 * Homepage JSON-LD. Previously stringified inside src/pages/Index.tsx and
 * injected through a duplicate <Helmet> block, which shipped a SECOND
 * homepage <link rel="canonical"> and forced a client-side head diff during
 * hydration. The route head() in src/routes/index.tsx is now the single
 * authoritative source for title/description/canonical/JSON-LD.
 */

export const HOME_AUTODEALER_JSONLD = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "AutoDealer",
  name: "Rex & Sons RVs",
  url: "https://www.rexandsonsrvs.com/",
  logo: "https://www.rexandsonsrvs.com/images/splash-assets/logo-400.webp",
  image: "https://www.rexandsonsrvs.com/images/splash-assets/hero-1920.webp",
  telephone: "+1-910-793-2894",
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: "5625 Barbados Blvd",
    addressLocality: "Castle Hayne",
    addressRegion: "NC",
    postalCode: "28429",
    addressCountry: "US",
  },
  areaServed: "Wilmington, NC",
  sameAs: ["https://www.facebook.com/RexAndSonsRVs"],
});

export const HOME_WEBSITE_JSONLD = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Rex & Sons RVs",
  url: "https://www.rexandsonsrvs.com/",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://www.rexandsonsrvs.com/rv-search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
});
